export const _MS_PER_DAY = 1000 * 60 * 60 * 24;

export const formatDate = (date) => {
  const [year, month, day] = date.slice(0, 10).split('-');
  const result = [day, month, year].join('/');
  return result;
};

export const getDaysDifferenceFromToday = (date) => {
  const today = new Date();
  const utc2 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const utc1 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

export const formatDateShort = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const months = ['jan.', 'fév.', 'mar.', 'avr.', 'mai', 'jun.', 'jul.', 'aoû.', 'sep.', 'oct.', 'nov.', 'déc.'];
  const month = months[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${month} ${day}, ${year}`;
};